// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Indian Type Foundry - Volte Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Indian Type Foundry - Volte.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Indian Type Foundry - Volte Semibold (1).otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Indian Type Foundry - Volte Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/Indian Type Foundry - Volte Medium (1).otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@font-face {
  font-family: 'Volte Light';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
  /* font-weight: 700;
  font-style: normal; */
}

@font-face {
  font-family: 'Volte';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Volte Semibold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: 'Volte Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('opentype');
  font-weight: 700;
  font-style: normal;
}


  @font-face {
    font-family: 'Volte Medium';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('opentype');
    font-weight: 500;
    font-style: normal;
}


/* Optional: Apply a default font globally */
body {
  font-family: 'Volte', sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,0BAA0B;EAC1B,+DAAkF;EAClF;uBACqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,+DAA2E;EAC3E,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,+DAA4F;EAC5F,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,+DAAiF;EACjF,gBAAgB;EAChB,kBAAkB;AACpB;;;EAGE;IACE,2BAA2B;IAC3B,+DAA0F;IAC1F,gBAAgB;IAChB,kBAAkB;AACtB;;;AAGA,4CAA4C;AAC5C;EACE,gCAAgC;AAClC","sourcesContent":[".App {\r\n  text-align: center;\r\n}\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: white;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n@font-face {\r\n  font-family: 'Volte Light';\r\n  src: url('../fonts/Indian\\ Type\\ Foundry\\ -\\ Volte\\ Light.otf') format('opentype');\r\n  /* font-weight: 700;\r\n  font-style: normal; */\r\n}\r\n\r\n@font-face {\r\n  font-family: 'Volte';\r\n  src: url('../fonts/Indian\\ Type\\ Foundry\\ -\\ Volte.otf') format('opentype');\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: 'Volte Semibold';\r\n  src: url('../fonts/Indian\\ Type\\ Foundry\\ -\\ Volte\\ Semibold\\ \\(1\\).otf') format('opentype');\r\n  font-weight: 600;\r\n  font-style: normal;\r\n}\r\n@font-face {\r\n  font-family: 'Volte Bold';\r\n  src: url('../fonts/Indian\\ Type\\ Foundry\\ -\\ Volte\\ Bold.otf') format('opentype');\r\n  font-weight: 700;\r\n  font-style: normal;\r\n}\r\n\r\n\r\n  @font-face {\r\n    font-family: 'Volte Medium';\r\n    src: url('../fonts/Indian\\ Type\\ Foundry\\ -\\ Volte\\ Medium\\ \\(1\\).otf') format('opentype');\r\n    font-weight: 500;\r\n    font-style: normal;\r\n}\r\n\r\n\r\n/* Optional: Apply a default font globally */\r\nbody {\r\n  font-family: 'Volte', sans-serif;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
